import api from './api';
import { sendEventLog } from './eventLog';

import { login } from './auth';
import { logError } from '../utils/logError';
import { isReactNativeWebView } from '../utils/isReactNativeWebView';
import { clearMcpOAuthParams, getLoginCallbackUrl } from '../utils/mcpOAuthParams';

export const loginUser = async (response) => {
  if (response.data?.token != '') {
    await login(response.data.token);
  }
};

export const redirectUser = async (response, creatingUser = false) => {
  const event = creatingUser ? 'signup_click_start-button' : 'login';

  try {
    await sendEventLog(event);
  } catch {
    logError('Error sending event');
  }

  if (isReactNativeWebView()) {
    await loginUser(response);
    window.ReactNativeWebView.postMessage(JSON.stringify({
      type: 'AUTH_SUCCESS',
      data: { token: response.data.token }
    }));
    return;
  }

  // Prefer MCP bridge resume when connecting from ChatGPT / MCP clients.
  const callbackUrl = getLoginCallbackUrl(response.data?.callback_url);
  clearMcpOAuthParams();
  window.location.assign(callbackUrl);
};
